import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
// Static plan apps array with category, icon (using Remix Icon classes), and description.
export const staticPlanApps = [
  {
    id: 1,
    name: "sales_crm",
    price: '{"monthly":15,"yearly":9,"biyearly":5}',
    category: "sales",
    icon: "ri-customer-service-2-line",
    description: "Manage your sales pipeline effectively.",
    limit: null,
  },
  {
    id: 2,
    name: "landing_pages",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "website",
    icon: "ri-layout-4-line",
    description: "Create stunning landing pages.",
    limit: 5,
  },
  {
    id: 3,
    name: "forms",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "website",
    icon: "ri-file-list-2-line",
    description: "Collect data easily with forms.",
    limit: 5,
  },
  {
    id: 4,
    name: "ai_chatbot",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "support",
    icon: "ri-robot-line",
    description: "Automate customer support with AI.",
    limit: null,
  },
  {
    id: 5,
    name: "booking",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "sales",
    icon: "ri-calendar-event-line",
    description: "Manage bookings and appointments.",
    limit: 20,
  },
  {
    id: 6,
    name: "appointments",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "sales",
    icon: "ri-calendar-2-line",
    description: "Schedule appointments seamlessly.",
    limit: 20,
  },
  {
    id: 7,
    name: "invoicing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "billing",
    icon: "ri-bill-line",
    description: "Generate and manage invoices.",
    limit: null,
  },
  {
    id: 8,
    name: "online_payments",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "billing",
    icon: "ri-secure-payment-line",
    description: "Accept online payments securely.",
    limit: null,
  },
  {
    id: 9,
    name: "estimates_quotes",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "sales",
    icon: "ri-file-copy-2-line",
    description: "Create estimates and quotes.",
    limit: null,
  },
  {
    id: 10,
    name: "pipeline_deals",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "sales",
    icon: "ri-stack-line",
    description: "Manage your pipeline deals.",
    limit: null,
  },
  {
    id: 11,
    name: "services_products",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "sales",
    icon: "ri-shopping-bag-3-line",
    description: "List services and products.",
    limit: 19,
  },
  {
    id: 12,
    name: "plans_subscriptions",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "billing",
    icon: "ri-checkbox-multiple-blank-line",
    description: "Manage plans and subscriptions.",
    limit: 19,
  },
  {
    id: 13,
    name: "agreements_with_e_sign",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "legal",
    icon: "ri-contract-line",
    description: "Sign agreements electronically.",
    limit: null,
  },
  {
    id: 14,
    name: "engagements",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-heart-line",
    description: "Boost customer engagement.",
    limit: null,
  },
  {
    id: 15,
    name: "coupons",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-coupon-line",
    description: "Offer discounts with coupons.",
    limit: 1,
  },
  {
    id: 16,
    name: "email_marketing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-mail-line",
    description: "Automate email marketing campaigns.",
    limit: null,
  },
  {
    id: 17,
    name: "sms_marketing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-sms-line",
    description: "Reach customers via SMS.",
    limit: null,
  },
  {
    id: 18,
    name: "whatsapp_marketing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-whatsapp-line",
    description: "Engage customers on WhatsApp.",
    limit: null,
  },
  {
    id: 19,
    name: "social_media_marketing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-share-box-line",
    description: "Promote your brand on social media.",
    limit: null,
  },
  {
    id: 20,
    name: "ab_testing",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "marketing",
    icon: "ri-asterisk-line",
    description: "Optimize your website with A/B testing.",
    limit: null,
  },
  {
    id: 21,
    name: "in_app_calling",
    price: '{"monthly":5,"yearly":2,"biyearly":1}',
    category: "support",
    icon: "ri-phone-line",
    description: "Make calls within your app.",
    limit: null,
  },
  {
    id: 22,
    name: "api_access",
    price: '{"monthly":35,"yearly":20,"biyearly":10}',
    category: "integration",
    icon: "ri-code-box-line",
    description: "Access our API for integrations.",
    limit: null,
  },
  {
    id: 23,
    name: "white_label",
    price: '{"monthly":45,"yearly":25,"biyearly":15}',
    category: "branding",
    icon: "ri-brush-line",
    description: "Customize branding with white label solutions.",
    limit: null,
  },
  {
    id: 24,
    name: "dedicated_resource",
    price: '{"monthly":75,"yearly":50,"biyearly":40}',
    category: "support",
    icon: "ri-team-line",
    description: "Get dedicated support resources.",
    limit: null,
  },
];

// Helper to calculate renewal dates based on cycle and subscription start date
export const getRenewalDates = (cycle, subscriptionStartDate) => {
  const startDate = new Date(subscriptionStartDate);
  const today = new Date();
  let currentCycleStart = new Date(startDate);
  let nextRenewalDate = new Date(startDate);

  if (cycle === "monthly") {
    while (nextRenewalDate <= today) {
      currentCycleStart = new Date(nextRenewalDate);
      nextRenewalDate.setMonth(nextRenewalDate.getMonth() + 1);
    }
  } else if (cycle === "yearly") {
    while (nextRenewalDate <= today) {
      currentCycleStart = new Date(nextRenewalDate);
      nextRenewalDate.setFullYear(nextRenewalDate.getFullYear() + 1);
    }
  } else if (cycle === "biyearly") {
    while (nextRenewalDate <= today) {
      currentCycleStart = new Date(nextRenewalDate);
      nextRenewalDate.setFullYear(nextRenewalDate.getFullYear() + 2);
    }
  }

  return { currentCycleStart, nextRenewalDate };
};

export const getRenewalDates1 = (
  cycle,
  subscriptionStartDate,
  chargeOn = null
) => {
  const startDate = dayjs.utc(subscriptionStartDate);
  let currentCycleStart = startDate;
  let nextRenewalDate = startDate;

  if (cycle === "monthly") {
    nextRenewalDate = nextRenewalDate.add(1, "month");
  } else if (cycle === "yearly") {
    nextRenewalDate = nextRenewalDate.add(1, "year");
  } else if (cycle === "biyearly") {
    nextRenewalDate = nextRenewalDate.add(2, "year");
  }

  if (chargeOn) {
    const daysInMonth = nextRenewalDate.daysInMonth();
    if (chargeOn <= daysInMonth) {
      nextRenewalDate = nextRenewalDate.date(chargeOn);
    }
  }

  return { currentCycleStart, nextRenewalDate };
};

// Helper for user-friendly billing cycle labels
export const getBillingCycleLabel = (billingCycle) => {
  switch (billingCycle) {
    case "yearly":
      return "per year";
    case "monthly":
      return "per month";
    case "biyearly":
      return "every two years";
    default:
      return billingCycle;
  }
};

// Helper to calculate the price for an app based on the billing cycle
export const getAppPrice = (app, billingCycle) => {
  if (!app.price) return 0;
  try {
    const priceObj = JSON.parse(app.price);
    let price = parseFloat(priceObj[billingCycle] || 0);
    if (billingCycle === "yearly") {
      price *= 12;
    } else if (billingCycle === "biyearly") {
      price *= 24;
    }
    return price;
  } catch (error) {
    console.error("Error parsing price for app", app, error);
    return 0;
  }
};

export const pluralize = (word) => {
  if (!word || typeof word !== "string") {
    throw new Error("Invalid input: Expected a string");
  }

  const lowerWord = word.toLowerCase();

  // Heuristic: if the word already appears plural, return it unchanged.
  // We assume that if it ends with "forms", "ies", or "es", it is plural.
  if (
    lowerWord.endsWith("forms") ||
    lowerWord.endsWith("ies") ||
    lowerWord.endsWith("es")
  ) {
    return word;
  }
  // Special handling: if word ends with a consonant followed by "y", replace "y" with "ies".
  if (
    word.endsWith("y") &&
    !["a", "e", "i", "o", "u"].includes(word[word.length - 2].toLowerCase())
  ) {
    return word.slice(0, -1) + "ies";
  }

  // For words ending in s, x, z, ch, or sh, add "es".
  const esEndings = ["s", "x", "z", "ch", "sh"];
  for (let ending of esEndings) {
    if (lowerWord.endsWith(ending)) {
      return word + "es";
    }
  }

  // Default: simply add "s".
  return word + "s";
};

export const getPlanPrice = (priceData, billingCycle) => {
  if (!priceData?.price) return 0;
  try {
    let price = parseFloat(priceData.price || 0);
    if (billingCycle === "yearly") {
      price *= 12;
    } else if (billingCycle === "biyearly") {
      price *= 24;
    }
    return price;
  } catch (error) {
    console.error("Error parsing price for plan", error);
    return 0;
  }
};

export const countDaysFromNow = (fromDate, toDate = null, fromStart = true) => {
  const futureDate = fromStart
    ? dayjs.utc(fromDate).startOf("day")
    : dayjs.utc(fromDate);

  const now = toDate
    ? fromStart
      ? dayjs.utc(toDate).startOf("day")
      : dayjs.utc(toDate)
    : fromStart
      ? dayjs.utc().startOf("day")
      : dayjs.utc();
  const diffInDays = futureDate.diff(now, "days");
  // console.log(
  //   "Current UTC:",
  //   fromDate,
  //   dayjs.utc(fromDate).format("YYYY-MM-DD hh:mm:s")
  // );
  return diffInDays;
};

export const getTotalCharge = (newBillingCycle, basePrice) => {
  if (newBillingCycle === "yearly") return basePrice * 12;
  if (newBillingCycle === "biyearly") return basePrice * 24;
  return basePrice;
};

export const billingLabel = {
  monthly: "Monthly",
  yearly: "Yearly",
  biyearly: "2 Yearly",
};
